import { ExportColumn } from '../../../interfaces/ExportColumn';

export const baseColumns: ExportColumn[] = [
  { key: 'locationName', header: 'Location', type: 'text', width: 45 },
  {
    key: 'supportedRevenue',
    header: 'Annual Revenue Supported',
    type: 'money',
    width: 35,
  },
  {
    key: 'suppliersCount',
    header: 'Suppliers Mapped',
    type: 'number',
  },
];

export const baseColumnsMapping: ExportColumn[] = [
  { key: 'name', header: 'Division', type: 'text', width: 45 },
  {
    key: 'supportedRevenue',
    header: 'Revenue Supported  Annually',
    type: 'money',
    width: 40,
  },
];

export const baseColumnsSummary: ExportColumn[] = [
  {
    key: 'supplierName',
    header: 'Supplier',
    type: 'text',
    width: 45,
  },
  {
    key: 'totalRevenue',
    header: 'Revenue Supported  Annually',
    type: 'money',
    width: 35,
  },
  {
    key: 'percentageOfLocationSupported',
    header: '% Of Location Supported',
    type: 'percentage',
  },
  {
    key: 'sourcingStatus',
    header: 'Sourcing Status',
    type: 'text',
  },
  {
    key: 'bcpUploaded',
    header: 'BCP Uploaded in MEO',
    type: 'boolean',
  },
  {
    key: 'bcpUpdatedAt',
    header: 'Supplier BCP Date',
    type: 'text',
    placeholder: 'No available date',
  },
];
